import React from 'react';

export default function IconEmptyList({
    width = '33',
    height = '36',
    ...rest
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 33 36"
            {...rest}
        >
            <defs>
                <linearGradient
                    id="paint0_linear"
                    x1="16.5"
                    y1="1.36594e-08"
                    x2="16"
                    y2="42"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E7E6E6" />
                    <stop offset="1" stopColor="#D4D4D4" />
                </linearGradient>
            </defs>
            <path
                fillRule="evenodd"
                d="M3.56469 6.29517C1.36678 7.53462 0 9.90267 0 12.4755V23.2653C0 25.7885 1.31353 28.1186 3.44566 29.377L13.0705 35.0601C15.1933 36.3133 17.8067 36.3133 19.9295 35.0601L29.5543 29.377C31.6854 28.1186 33 25.7885 33 23.2653V12.4755C33 9.90267 31.6343 7.53462 29.4353 6.29517L19.8104 0.871785C17.7493 -0.290595 15.2517 -0.290595 13.1896 0.871785L3.56469 6.29517ZM28.8757 23.2653V13.7488L20.0047 18.2262C19.1213 18.6717 18.5637 19.5849 18.5637 20.5826V30.9839L27.4974 25.7093C28.3494 25.2068 28.8757 24.2746 28.8757 23.2653ZM14.4383 30.9849L5.5047 25.7104C4.65164 25.2068 4.12644 24.2746 4.12644 23.2653V13.4162L13.0538 18.1987C13.9058 18.6559 14.4394 19.5512 14.4394 20.5267V30.9849H14.4383ZM17.8245 4.57852L27.2103 9.86783L18.76 14.4012C17.3202 15.173 15.5984 15.1497 14.1804 14.3358L6.09255 9.69679L15.1755 4.57747C16.0014 4.11399 16.9996 4.11399 17.8245 4.57852Z"
                fill="url(#paint0_linear)"
            />
        </svg>
    );
}
